import * as React from 'react';
/**
 *
 * Original name: Data Rooms
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=54898%3A41
 *
 */
export const DataRoomsFill = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m12 2.54 8.594 6.874-.938 1.171L18.5 9.66V19h-13V9.66l-1.156.925-.938-1.17L12 2.538ZM10 11c0-1.346.654-2 2-2s2 .654 2 2c0 1.066-.41 1.698-1.25 1.915V15h-1.5v-2.085C10.41 12.698 10 12.066 10 11Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
